var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrailerEmpty = function SvgIconTrailerEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D5E2F2",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4 7.2a7.2 7.2 0 0 1 7.199 7.2V29.64h3.6v-7.025c0-1.491 1.311-2.816 2.802-2.816s2.597 1.325 2.598 2.816v9.725c0 .716-.183 1.403-.689 1.91a2.7 2.7 0 0 1-1.909.79h-6.402v9.275a.905.905 0 0 1-1.385.765c-3.425-2.137-8.47-5.151-13.015-7.345V26.1H36c-1.491 0-2.7-1.21-2.7-2.701v-7.2a2.7 2.7 0 0 1 5.4 0v4.5h4.5v-6.3a7.2 7.2 0 0 1 7.2-7.2m0 21.6v5.4h5.399v-5.4zm-3.601-7.2h5.4v-5.4h-5.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.001,
    cy: 30.6,
    r: 7.2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.711 56.235 44.575 44.244a18 18 0 0 0-17.147 0L5.292 56.234C2.007 58.015 3.27 63 7.006 63h57.99c3.736 0 5-4.986 1.715-6.765",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.9 44.1 5.371 56.23C2.079 58.005 3.338 63 7.078 63H64.8c-3.6-.9-8.1-2.7-13.5-4.5s-10.8-6.3-12.6-10.8c-1.002-2.506-4.81-7.199-10.8-3.6",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTrailerEmpty;